import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import { successCopy } from '@/Pages/Success/copy';
import { useSuccessAnimation } from '@/Pages/Success/hooks/useSuccessAnimation';
import '@/Pages/Success/SuccessPage.sass';

export function SuccessHeader(): JSX.Element {
  const { reduceMotion, title, subtitle } = useSuccessAnimation();

  if (reduceMotion) {
    return (
      <Box
        component="section"
        className="success-header"
        data-testid="success-header"
        data-motion="reduced"
        role="status"
        aria-atomic="true"
      >
        <Typography component="h1" className="success-header__title">
          {successCopy.title}
        </Typography>
        <Typography component="p" className="success-header__subtitle">
          {successCopy.subtitle}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      component="section"
      className="success-header"
      data-testid="success-header"
      data-motion="animated"
      role="status"
      aria-atomic="true"
    >
      <Typography
        component={motion.h1}
        className="success-header__title"
        initial={title.initial}
        animate={title.animate}
        transition={title.transition}
      >
        {successCopy.title}
      </Typography>
      <Typography
        component={motion.p}
        className="success-header__subtitle"
        initial={subtitle.initial}
        animate={subtitle.animate}
        transition={subtitle.transition}
      >
        {successCopy.subtitle}
      </Typography>
    </Box>
  );
}
